export enum StrategyEnum {
  FirebaseStorage = "firebase",
  GCore = "gcore",
}
